module.exports = __webpack_public_path__ + "img/WelcomeVideo.68c12f67.png";